/* eslint-disable max-len */

import React from 'react'
import styled from 'styled-components'

const AnnualAssetsGoalsTutorialStyled = styled.div`
  position: absolute;
  left: calc(100% + 29px);
  bottom: 10px;
  z-index: 2;
`

const TutorialContent = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: left;
  display: inline-block;
  width: 100%;

  letter-spacing: 1px;

  color: #000000;
`

const AnnualAssetsGoalsTutorial = () => (
  <AnnualAssetsGoalsTutorialStyled>
    <svg width="324" height="124" viewBox="0 0 324 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M78.73 82L44.1655 97.8913L-0.000175476 116L78.73 97.8913V82Z" fill="#D4D4FA" />
      <g filter="url(#filter0_d_2466_11977)">
        <rect x="77.0369" y="5" width="242.963" height="111" rx="10" fill="#DAD9FF" />
        <rect x="77.5369" y="5.5" width="241.963" height="110" rx="9.5" stroke="#D9D9D9" />
      </g>
      <circle cx="77.7202" cy="21" r="20.5" fill="#3B82F6" stroke="#3B82F6" />
      <path
        d="M82.5002 27.2686H72.5202V25.1686L76.1002 21.5486C76.8202 20.8019 77.4002 20.1819 77.8402 19.6886C78.2802 19.1819 78.6002 18.7286 78.8002 18.3286C79.0002 17.9152 79.1002 17.4752 79.1002 17.0086C79.1002 16.4352 78.9402 16.0086 78.6202 15.7286C78.3135 15.4486 77.8935 15.3086 77.3602 15.3086C76.8135 15.3086 76.2802 15.4352 75.7602 15.6886C75.2402 15.9419 74.6935 16.3019 74.1202 16.7686L72.4802 14.8286C72.8802 14.4819 73.3135 14.1552 73.7802 13.8486C74.2469 13.5286 74.7802 13.2752 75.3802 13.0886C75.9935 12.8886 76.7269 12.7886 77.5802 12.7886C78.5135 12.7886 79.3135 12.9619 79.9802 13.3086C80.6602 13.6419 81.1802 14.1019 81.5402 14.6886C81.9135 15.2619 82.1002 15.9152 82.1002 16.6486C82.1002 17.4352 81.9402 18.1552 81.6202 18.8086C81.3135 19.4619 80.8602 20.1086 80.2602 20.7486C79.6735 21.3886 78.9602 22.0952 78.1202 22.8686L76.2802 24.5886V24.7286H82.5002V27.2686Z"
        fill="white"
      />
      <foreignObject className="node" x="100" y="22" width="200" height="300">
        <TutorialContent>
          click EDIT icon <br />
          and input each <br />
          parameters.
        </TutorialContent>
      </foreignObject>
      <defs>
        <filter
          id="filter0_d_2466_11977"
          x="73.0369"
          y="5"
          width="250.963"
          height="119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2466_11977" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2466_11977" result="shape" />
        </filter>
      </defs>
    </svg>

  </AnnualAssetsGoalsTutorialStyled>
)

export default AnnualAssetsGoalsTutorial
